/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventUserRpc
 */

/**
 *  Empty request — the portalId and userId used to evaluate the onboarding activation window
 *  are read from the ChirpContext.
 */

export const getEventsRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEvents',
  auth: 'app',
  fingerprint: 'SlWg-polWOP5kKgXryf4lzAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEventByIdRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEventById',
  auth: 'app',
  fingerprint: '4IYhRG_IfYLQ5XfyJolKwzAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEventRecordingRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEventRecording',
  auth: 'app',
  fingerprint: 'AMdnoUlzBQzC0BRG1mxXTzAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNextRecommendedLiveEventRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getNextRecommendedLiveEvent',
  auth: 'app',
  fingerprint: '9PGGlAaFKYvgTneAhG5icTAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOnboardingActivationStatusRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getOnboardingActivationStatus',
  auth: 'app',
  fingerprint: 'QbSssHAzJcKUwf6bYaHlPzAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};